// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"86":"be22b981","169":"2417eeca","355":"9aad00ec","405":"76f2e0d9","423":"65e058c9","505":"b2caa951","666":"d1c86796","694":"3d099c20","775":"f84f7fae","806":"51b84b64","814":"8f212523","872":"f7c7ef45","897":"a48cb3e0"}[chunkId] + ".chunk.js";
};